// MpgInfoDialog.jsx
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const MpgInfoDialog = ({ title, content, open, setOpen }) => {
  const handleClose = () => setOpen(false);

  let dialogContent = "";
  if (content?.includes("\n")) {
    dialogContent = content.split("\n").map((str, i) => <p key={i}>{str}</p>);
  } else {
    dialogContent = content;
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ m: 0, p: 2 , textAlign: "center",fontWeight: "bold"   }}>
        {title || "Message"}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {dialogContent || ""}
        </DialogContentText>
      </DialogContent>

      <DialogActions  sx={{
          justifyContent: "center",   // center the OK button
          pb: 2,
        }}>
        <Button onClick={handleClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default MpgInfoDialog;
